(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var link = document.getElementById('s81-cart-float-link');
    var countEl = document.getElementById('s81-cart-float-count');
    if (!link || !countEl) return;

    function render(itemCount) {
      var count = typeof itemCount === 'number' ? itemCount : 0;
      link.classList.toggle('is-visible', count > 0);
      countEl.textContent = count < 100 ? String(count) : '99+';
    }

    function refreshFromServer() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          render(cart.item_count);
        })
        .catch(function () {});
    }

    document.addEventListener('cart:update', function (event) {
      var resource = event.detail && event.detail.resource;
      if (resource && typeof resource.item_count === 'number') {
        render(resource.item_count);
      } else {
        refreshFromServer();
      }
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refreshFromServer();
    });
  });
})();
